import React from 'react';
import { brand, ctaLabel, price } from '../data/content';
import { handleScrollClick } from './CtaButton';
export function TopBar() {
  return <header className="border-b border-cream-line bg-cream" data-id="element-224" data-mp="231lttnhvrn30">
      <div className="mx-auto flex h-16 max-w-page items-center justify-between gap-3 px-5 md:px-8" data-id="element-225" data-mp="1y4vej2dwgvin">
        <a href="#top" className="whitespace-nowrap font-display text-[15px] font-extrabold tracking-tight text-teal md:text-[18px]" data-id="element-226" data-mp="1t5r7oieg79vh">
          {brand}
        </a>
        <a href="#offer" onClick={handleScrollClick} className="inline-flex h-10 shrink-0 items-center whitespace-nowrap rounded-lg bg-orange px-3 text-[12px] font-bold tracking-[0.02em] text-white transition-colors duration-150 ease-out hover:bg-orange-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange md:px-4 md:text-[13px]" data-id="element-227" data-mp="2ltepxqs8xoey">
          <span className="sm:hidden" data-id="element-228" data-mp="34r7qimfedm96">GET IT · {price}</span>
          <span className="hidden sm:inline" data-id="element-229" data-mp="257szzecevd8">{ctaLabel}</span>
        </a>
      </div>
    </header>;
}